import { createContext, useContext } from 'react';
import { useQueryClient } from 'react-query';
import { useMstInstanceCreator } from 'utils/mst/useMstInstanceCreator';
import { CanvasStore, createCanvasStore } from 'modules/Canvas/store/canvasStore';

export const CanvasStoreCtx = createContext<CanvasStore>(null as unknown as CanvasStore);

export function useCanvasStore(): CanvasStore {
  return useContext(CanvasStoreCtx);
}

export function useCreateCanvasStore(env: CF.MSTEnvironment): ReturnType<typeof createCanvasStore> {
  const queryClient = useQueryClient();
  const store = useMstInstanceCreator(createCanvasStore, [], () => [undefined, { queryClient, env }]);

  return store;
}
